import ArrowRightIcon from "@/components/_icons/arrowRightIcon";
import { PrimaryButton } from "@/components/button/primaryButton";

export interface SendToKitchenButtonProps {
  merchantColor: string;
  buttonText: string;
  isButtonDisabled: boolean;
  onClick: () => void;
}

export const SendToKitchenButton = ({
  merchantColor,
  buttonText,
  isButtonDisabled,
  onClick,
}: SendToKitchenButtonProps) => {
  return (
    <div
      data-testid="send-to-kitchen-button"
      style={{ backgroundColor: !isButtonDisabled ? merchantColor : "#C7C7C7" }}
      className="min-h-16 text-[#fff] cursor-pointer"
      onClick={!isButtonDisabled ? onClick : () => {}}
    >
      <div className="px-[18px] flex justify-between items-center">
        <p className="pt-[18px] text-xl font-medium">{buttonText}</p>
        <div className="pt-5">
          <ArrowRightIcon color="#fff" height={24} width={24} />
        </div>
      </div>
    </div>
  );
};
